export enum ChatStatus {
  NoMessage = 0,
  MessageFromGp = 1,
  MessageFromDermatologist = 2,
}
